export default __webpack_public_path__ + "static/media/tool-icon-cone-blue.d5201ac7.svg";